import en from '@/lang/en';
import ja from '@/lang/ja';
import zh from '@/lang/zh';

export default {
  locale: 'en',
  fallbackLocale: 'ja',
  messages: {
    en: en.messages,
    ja: ja.messages,
    zh: zh.messages
  }
}
